import getLocalString from "constants/Localization";
import { useDeleteDailyFormInspectionQuestionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormInspectionQuestion() {
  const [mutation, { loading, data, error }] = useDeleteDailyFormInspectionQuestionMutation({
    refetchQueries: ["getDailyFormInspectionQuestions"],
  });

  const [deleteDailyFormInspectionQuestion, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteDailyFormInspectionQuestion",
    },
    {
      successMessage: getLocalString("fleet.delete-inspection-question-success"),
      failureMessage: getLocalString("fleet.delete-inspection-question-failure"),
    }
  );

  return [deleteDailyFormInspectionQuestion, context] as const;
}
